import React from 'react';
import { ACCOUNTS, TESTIMONIALS } from '../mock';
import { Check, Star } from 'lucide-react';

export const AccountTypes = () => (
  <section className="py-24 relative">
    <div className="max-w-[1400px] mx-auto px-6">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <div className="text-xs font-semibold tracking-widest text-[#00e676] mb-3">ACCOUNTS</div>
        <h2 className="text-4xl md:text-5xl font-extrabold text-white">More Choice. More Control.</h2>
        <p className="mt-4 text-gray-400">New account types designed to support your trading strategy and execution style.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {ACCOUNTS.map(a => (
          <div key={a.name} className={`relative p-8 rounded-2xl border ${a.popular ? 'border-[#00e676] bg-gradient-to-b from-[#0a1a13] to-[#0a1210] green-glow' : 'border-[#1a2823] bg-[#0a1210]'} feature-card`}>
            {a.popular && (
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-[#00e676] text-black text-[10px] font-bold tracking-wider">MOST POPULAR</div>
            )}
            <h3 className="text-xl font-bold text-white">{a.name}</h3>
            <div className="mt-4 flex items-baseline gap-2">
              <span className="text-5xl font-extrabold text-[#00e676] mono">{a.price}</span>
              <span className="text-sm text-gray-400">{a.priceLabel}</span>
            </div>
            <ul className="mt-6 space-y-3">
              {a.features.map(f => (
                <li key={f} className="flex items-start gap-2 text-sm text-gray-300">
                  <Check size={16} className="text-[#00e676] flex-shrink-0 mt-0.5"/> <span>{f}</span>
                </li>
              ))}
            </ul>
            <button className={`w-full mt-8 py-3 rounded-full font-semibold text-sm ${a.popular ? 'btn-green' : 'btn-outline-green'}`}>
              Open {a.name.split(' ')[0]} Account
            </button>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const Testimonials = () => {
  const row1 = TESTIMONIALS.slice(0, 4);
  const row2 = TESTIMONIALS.slice(4, 8);
  return (
    <section className="py-24 border-y border-[#141f1b] bg-[#070c0a] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 mb-12">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-xs font-semibold tracking-widest text-[#00e676] mb-3">CLIENT REVIEWS</div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-white">Trusted by Performance‑Driven Traders Worldwide</h2>
        </div>
      </div>
      <div className="space-y-6">
        <TRow items={row1}/>
        <TRow items={row2} reverse/>
      </div>
    </section>
  );
};

const TRow = ({ items, reverse }) => (
  <div className="overflow-hidden">
    <div className="flex gap-6" style={{ animation: `ticker ${reverse ? '65s' : '55s'} linear infinite`, animationDirection: reverse ? 'reverse' : 'normal' }}>
      {[...items, ...items, ...items].map((t, i) => (
        <div key={`${t.name}-${i}`} className="min-w-[340px] max-w-[340px] p-6 rounded-2xl border border-[#1a2823] bg-[#0a1210]">
          <div className="flex gap-0.5 mb-3">
            {[...Array(5)].map((_, s) => <Star key={s} size={14} className="fill-[#00e676] text-[#00e676]"/>)}
          </div>
          <p className="text-sm text-gray-300 leading-relaxed">&ldquo;{t.text}&rdquo;</p>
          <div className="mt-5 flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-[#00e676]/15 border border-[#00e676]/30 flex items-center justify-center text-[#00e676] text-xs font-bold">{t.initials}</div>
            <div>
              <div className="text-sm text-white font-semibold">{t.name}</div>
              <div className="text-xs text-gray-400">{t.role}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);
